import React from 'react';
import CertificationReportHeader from '../certification-report-header';
import CertificationReportItem from '../certification-report-item';

interface CertificationReportListProps {
  reportList: any[];
}

const CertificationReportList: React.FC<CertificationReportListProps> = ({ reportList }) => {
  return (
    <div style={{ minWidth: '1000px' }}>
      <CertificationReportHeader />
      {reportList.map((item: any, index: number) => (
        <CertificationReportItem item={item} key={item.id || item._id || index} />
      ))}
    </div>
  );
};

export default CertificationReportList;
